// ##################################### IMPORT PART
import React, { useState, useEffect, useCallback, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import styled from "styled-components";
import debounce from "lodash/debounce";
import GlobalStyle from './GlobalStyle';
// ####################################  END IMPORT PART

// ######################################### STYLES BUTTON ECC
const CheckboxWrapper = styled.div`
  margin-top: 1rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;
const FormContainer = styled.div`
  background-color: #fff9c4; /* giallo chiaro */
  max-width: 600px;
  margin: auto;
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  position: relative;
`;
const Input = styled.input`
  width: 100%;
  padding: 10px;
  margin: 10px 0;
  border: 1px solid #ccc;
  border-radius: 4px;
`;
const Button = styled.button`
  width: 100%;
  padding: 10px;
  background: #28a745;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 10px;
  &:hover {
    background: #218838;
  }
`;
const ListContainer = styled.ul`
  margin-top: -5px; /* poco margine se serve */
  border: 1px solid #ccc;
  padding: 0;
  list-style: none;
  max-height: 200px;
  overflow-y: auto;
  background: white;
  width: 100%;
  border-radius: 4px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
`;
const ListItem = styled.li`
  padding: 10px;
  cursor: pointer;
  background: #f9f9f9;
  border-bottom: 1px solid #ddd;
  &:hover {
    background: #e0e0e0;
  }
`;
const Select = styled.select`
  width: 100%;
  padding: 10px;
  margin: 10px 0;
  border: 1px solid #ccc;
  border-radius: 4px;
`;
const QuantityContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
`;
const QuantityInput = styled(Input)`
  width: 70%;
`;
const UnitSelect = styled(Select)`
  width: 30%;
  margin-left: 10px;
`;
const InputWrapper = styled.div`
  position: relative;
  width: 100%;
`;
// ################################################################################## END STYLES BUTTON ECC

// ############################################################# COMPONENT
const AddProduct = ({ existingOrderId = null, initialFormattedOrderId = null, returnToEditProducts = false }) => {
 const navigate = useNavigate();
 const [formattedOrderId, setFormattedOrderId] = useState(initialFormattedOrderId || "");
 const [orderId, setOrderId] = useState("");
 const [productName, setProductName] = useState("");
 const [code, setCode] = useState("");
 const [quantity, setQuantity] = useState("");
 const [filteredProducts, setFilteredProducts] = useState([]);
 const [filteredCustomers, setFilteredCustomers] = useState([]);
 const [loading, setLoading] = useState(false);
 const [setNoResults] = useState(false);
 const [showProductList, setShowProductList] = useState(false);
 const [showCustomerList, setShowCustomerList] = useState(false);
 const [unit, setUnit] = useState("");
 const [unitOptions, setUnitOptions] = useState([]);
 const [customer, setCustomer] = useState("");
 const [orderDate, setOrderDate] = useState(() => {
  const today = new Date();
  return today.toISOString().split("T")[0]; // YYYY-MM-DD
 });
 const [iva, setIva] = useState("");
 const [isFirstProduct, setIsFirstProduct] = useState(!existingOrderId);
 const dropdownRef = useRef(null);
 const [purchasePrice, setPurchasePrice] = useState(null);
 const [salePrices, setSalePrices] = useState([]);
 const [products, setProducts] = useState([]);
 const [selectedSalePrice, setSelectedSalePrice] = useState("");
 const [alternativeQuantity, setAlternativeQuantity] = useState("");
 const [productsToEdit, setProductsToEdit] = useState([]);
 const [currentProductIndex, setCurrentProductIndex] = useState(0);
 const [pagato, setPagato] = useState(false);
 const [manualSalePrice, setManualSalePrice] = useState("");
 const [isManualPrice, setIsManualPrice] = useState(false);
 const [manualPriceValue, setManualPriceValue] = useState("");
 const [lotto, setLotto] = useState('');
 const [tipoCliente, setTipoCliente] = useState("privato");
 const effectiveSalePrice = selectedSalePrice === "manuale" ? manualSalePrice : selectedSalePrice;
 const partialPrice = quantity && effectiveSalePrice ? (parseFloat(quantity) * parseFloat(effectiveSalePrice.replace(/[^\d.]/g, ''))).toFixed(2) : "0.00";
 const [IdForSearch, setIdForSearch] = useState("");
 const [codCliente, setCodCliente] = useState("");

useEffect(() => { if (existingOrderId && !formattedOrderId) { setFormattedOrderId(existingOrderId); } }, [existingOrderId, formattedOrderId]);
const handleAddProduct = async () => {
  if (!productName || !code) {
    return alert("Please enter all product details.");
  }
  if (isFirstProduct && (!customer || !orderDate)) {
    return alert("Please enter customer and order date.");
  }
  const onlyDate = orderDate.includes("T") ? orderDate.split("T")[0] : orderDate;
  const generatedId = `${customer.trim()} - ${onlyDate}`;

// CREA ORDINE SE NECESSARIO
if (isFirstProduct) {
  let baseId = generatedId;
  let finalId = baseId;
  let counter = 1;
  let orderExists = true;
  while (orderExists) {
    try {
      const res = await axios.get(`/api/corrs/${encodeURIComponent(finalId)}`);
      counter++;
      finalId = `#${counter} ${baseId}`;
    } catch (error) {
      if (error.response && error.response.status === 404) {
        orderExists = false;
      } else {
        console.error("Errore nella verifica ordine:", error);
        return;
      }
    }
  }

  try {
    await axios.post("/api/NewCorr", {
      orderId: finalId,
      customer,
      orderDate,
      pagato: pagato ? "si" : "no",
      tipoCliente,
      esportato: "no"
    });
    setFormattedOrderId(finalId);
    setOrderId(finalId);
    setIsFirstProduct(false);
  } catch (error) {
    console.error("Errore nella creazione dell'ordine:", error);
    return;
  }
}

// ###### DETERMINA ID CORRETTO
const orderToUse = formattedOrderId || generatedId;
try {
  await axios.post(`/api/corrs/${orderToUse}/products`,
    { productName, quantity: parseFloat(quantity), unit, alternativeQuantity, customer, orderDate, code, purchasePrice, selectedSalePrice: selectedSalePrice === "manuale" ? `${manualSalePrice} €` : selectedSalePrice, partialPrice, lotto, iva});

// Successivo prodotto o reset
if (productsToEdit.length > 0 && currentProductIndex < productsToEdit.length - 1) { setCurrentProductIndex(currentProductIndex + 1);
 } else {
  setProductsToEdit([]); setCurrentProductIndex(0); setProductName(""); setQuantity(""); setUnit(""); setCode(""); setPurchasePrice(null); setSelectedSalePrice(""); setManualSalePrice(""); setAlternativeQuantity(""); setFilteredProducts([]); setShowProductList(false); setLotto(""); }
  } catch (error) {
    console.error("Error adding product:", error);
  }
};
//

// Prezzo acquisto
 const fetchPurchasePrice = async (code) => {
  if (!code) return;
   const cleanedCode = code.replace(/\s+/g, '');
  try {
   const response = await axios.get(
        `/api/prezzoacq/${encodeURIComponent(cleanedCode)}`
      );
      setPurchasePrice(response.data.price ?? "N/A");
    } catch {
      setPurchasePrice("Error");
    }
  };

// Prezzi vendita
 const fetchSalePrices = async (code, codClienteParam = "") => {
  if (!code) return;
  const cleanedCode = code.replace(/\s+/g, '');
  const clientCode = (codClienteParam || "").trim();
  try {
   const response = await axios.get(`/api/prezzoven/${encodeURIComponent(cleanedCode)}${clientCode ? `?codCliente=${clientCode}` : ""}`);
    const data = Array.isArray(response.data) ? response.data : [response.data];
    const sortedPrices = data.map(p => `${parseFloat(p.PREZZO).toFixed(2)} €`);
    setSalePrices(sortedPrices);
  } catch (error) {
    console.error("Errore nel caricamento dei prezzi di vendita:", error);
  }
 };

// Debounced clienti
const fetchFilteredCustomers = useCallback(
  debounce(async (filter) => {
  if (!filter) {
  setFilteredCustomers([]);
  setShowCustomerList(false);
   return;
  }
  setLoading(true);
   try {
    const { data } = await axios.get( `/api/clienti?filter=${filter}` );
     setFilteredCustomers(data);
     setShowCustomerList(Boolean(data.length));
   } catch (error) { console.error(error); } finally { 
        setLoading(false);
      }
    }, 500),
    [IdForSearch]
);

// Popola subito customer per filtrare prodotti già acquistati
const generateIdForSearch = (cust, date) => {
  if (!cust || !date) return "";
  const normalizedCustomer = cust.trim().replace(/\s+/g, " ");
  return `${normalizedCustomer} - ${date}`;
};

// Use effects per debounce clienti
useEffect(() => {
  const newId = generateIdForSearch(customer, orderDate);
  setIdForSearch(newId);
}, [customer, orderDate]);

useEffect(() => {
}, [IdForSearch]);
// #######################################


// Debounce Prodotti
const fetchFilteredProducts = useCallback(
  debounce(async (filter, idSearch) => {
    if (!filter) { setFilteredProducts([]); setShowProductList(false); return; } setLoading(true);
    try {
      const { data } = await axios.get(`/api/products?filter=${filter}&IdForSearch=${idSearch}`
      );
      if (data.length) {
        const sorted = [...data].sort((a, b) => {
          if (a.source === 'internal' && b.source !== 'internal') return -1;
          if (a.source !== 'internal' && b.source === 'internal') return 1;
          return 0;
        });
     const combined = sorted.map(p => {
      const code = (p.code || p.productCode || "").trim();
      const name = (p.productName || "").trim();
      const ARUNMIS1 = (p.ARUNMIS1 || "").trim();
      const ARUNMIS2 = (p.ARUNMIS2 || "").trim();
      let dateInfo = "";
       if (p.source === "internal" && p.date) {
      dateInfo = ` (${p.date})`;
      }
        return {
        ...p,
         ARCODART: code,
         ARDESART: name,
	 ARUNMIS1: ARUNMIS1,
	 ARUNMIS2: ARUNMIS2,
         ARCODIVA: p.iva || p.ARCODIVA || "",
         combinedDescription: `${code} ${name} ${dateInfo}`,
	 cleanDescription: `${code} ${name}`
        };
     });
        setFilteredProducts(combined);
        const firstInternal = combined.find(p => p.source === 'internal');
        if (firstInternal) {
          fetchPurchasePrice(firstInternal.code || firstInternal.productCode);
          await fetchSalePrices(firstInternal.code || firstInternal.productCode);
        }
        setShowProductList(true);
        setNoResults(false);
      } else {
        setNoResults(true);
        setShowProductList(false);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, 500),
  []
);
// ###################################################################################################

// Logica per ordine già esistente
useEffect(() => {
if (existingOrderId) {
  axios
    .get(`/api/corrs/${existingOrderId}`)
  .then((res) => {
    const order = res.data;
    tipoCliente = (order.tipoCliente || "privato");
    console.log("Risposta ordine esistente:", order);
    if (order.products && order.products.length > 0) {
      const productData = order.products[0];
      const parsedProducts = productData.products
        ? (typeof productData.products === 'string' ? JSON.parse(productData.products) : productData.products)
        : [];
      setOrderId(order.orderId);
      setCustomer(parsedProducts[0]?.customer?.trim() || "");
      setOrderDate(order.orderDate);
      setProducts(parsedProducts);
      setSelectedSalePrice(order.selectedSalePrice);
      setSelectedSalePrice( order.selectedSalePrice != null ? String(order.selectedSalePrice) : "" );
      setProductsToEdit(parsedProducts);
      setIsFirstProduct(false);
      setCurrentProductIndex(0);
    } else {
      console.error("Ordine non trovato o prodotti assenti.");
    }
  })
  .catch((err) =>
    console.error("Errore caricamento ordine esistente:", err)
  );
// #########################################


// intercetta click fuori da dropdown
    const handleClickOutside = e => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setShowProductList(false);
        setShowCustomerList(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {document.removeEventListener("mousedown", handleClickOutside);};}
    }, [existingOrderId]);
// ##############################################

// Get codice cliente                                                                                                                
const fetchCodCliente = async (nomeCliente) => {
  if (!nomeCliente) return;
  try {
   const response = await axios.get(`/api/cliente-codice?nome=${encodeURIComponent(nomeCliente)}`);
   setCodCliente(response.data.codice || "");
  } catch (error) {
   console.error("Errore nel recupero del codice cliente:", error);
   setCodCliente("");
  }
};


// termina e salva ordine
const handleFinish = async () => {
  try {
    alert("✅ Order completed.");
    if (returnToEditProducts) {
      const url = `/corrs-edit-products/${orderId}`;
      window.location.href = url;
    } else {
      navigate("/Corrispettivi");
    }
  } catch (error) {
    console.error("Errore nel completare l'ordine:", error);
    alert("❌ Errore nel completare l'ordine");
  }
};
//
// ######################################################################################################################


// RETURN
return (
 <>
 <GlobalStyle />
  <FormContainer ref={dropdownRef}>
   <h4>Aggiungi/modifica prodotto a corrispettivo {orderId}</h4>
    {isFirstProduct && (
     <>
     <label>Customer:</label>
     <Input
       value={customer}
       onChange={e => {
       const val = e.target.value;
       setCustomer(val);
       if (val.trim().length >= 3) {
        fetchFilteredCustomers(val);
        setShowCustomerList(true);
       } else {
        setFilteredCustomers([]); 
        setShowCustomerList(false); } }} 
        onFocus={() => { if (customer.trim().length >= 3 && filteredCustomers.length > 0) { setShowCustomerList(true); } }} placeholder="Scrivi cliente o seleziona da lista"/>
      {showCustomerList && (
      <ListContainer>
       {filteredCustomers.map(c => ( 
         <ListItem key={c.ANDCODICE} onClick={() => { setCustomer(c.ANDESCRI); setShowCustomerList(false); }}> {c.ANDESCRI}
         </ListItem>
       ))}
      </ListContainer>
      )}

<CheckboxWrapper>
  <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
    <input
      type="checkbox"
      checked={pagato}
      onChange={e => setPagato(e.target.checked)}
    />
    Pagato
  </label>

  <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
    Tipo cliente:
    <select
      value={tipoCliente}
      onChange={(e) => {
        const value = e.target.value;
        setTipoCliente(value);
        if (value === "privato") {
          setIva("0"); 
        }
      }}
      style={{
        padding: '6px',
        borderRadius: '4px',
        border: '1px solid #ccc'
      }}
    >
      <option value="privato">Privato</option>
      <option value="azienda">Azienda</option>
    </select>
  </label>
</CheckboxWrapper> 

      </>
     )}

     <label>Product Name:</label>
     <Input value={productName} onChange={e => { setProductName(e.target.value); fetchFilteredProducts(e.target.value, IdForSearch); }}
      onFocus={() => {
     if (productName.trim().length > 1) setShowProductList(true);
        }}
      />

    {showProductList && (
     <ListContainer>
    {filteredProducts.map(p => (
     <ListItem
       key={p.ARCODART}
       onClick={() => {
         setCode(p.ARCODART);
         setProductName(p.cleanDescription);
         setUnitOptions([p.ARUNMIS1, p.ARUNMIS2].filter(Boolean));
	 setUnit(p.ARUNMIS1 || p.ARUNMIS2 || "");
         setShowProductList(false);
         fetchPurchasePrice(p.ARCODART);
         fetchSalePrices(p.ARCODART);
	 setIva(p.ARCODIVA || "0");
       }}
        style={{
          fontWeight: p.source === "internal" ? "bold" : "normal",
          backgroundColor: p.source === "internal" ? "#e6f7ff" : "transparent",
          padding: "6px 10px",
          cursor: "pointer"
        }}
     >
     {p.combinedDescription}
     </ListItem>
    ))}
  </ListContainer>
  )}

    <label>Quantità sistema:</label>
    <QuantityContainer>
     <QuantityInput type="number" value={quantity} onChange={e => setQuantity(e.target.value)} />
     <UnitSelect value={unit} onChange={e => setUnit(e.target.value)}>
     {unitOptions.map((opt, i) => <option key={i} value={opt}>{opt}</option>)}
     </UnitSelect>
    </QuantityContainer>

    <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}> Lotto:
      <input
       type="text"
       value={lotto}
       onChange={e => {
         const val = e.target.value.toUpperCase();
         if (val.length <= 6) setLotto(val);
       }}
      maxLength={8} style={{ width: '100px', padding: '4px 8px', borderRadius: '4px', border: '1px solid #ccc' }      } /> 
    </label>

    <div style={{ display: 'grid', gridTemplateColumns: '150px 1fr', gap: 10, alignItems: 'center' }}>
    <label>Quantità alternativa:</label>
    <Input value={alternativeQuantity} onChange={e => setAlternativeQuantity(e.target.value)} placeholder="Es: 4 barattoli" />
    <label>Prezzo acquisto:</label>
    <Input value={purchasePrice ?? ''} readOnly />
    <label>Prezzo vendita:</label>
     <Select value={selectedSalePrice} onChange={e => {
      const val = e.target.value;
      setSelectedSalePrice(val);
      if (val !== "manuale") setManualSalePrice("");
      }}>
      <option value="">Seleziona un prezzo</option>
      {salePrices.map((sp, i) => <option key={i} value={sp}>{sp}</option>)}
      <option value="manuale">Inserisci manualmente</option>
     </Select>
   {selectedSalePrice === "manuale" && (
   <div style={{ gridColumn: "1 / span 2" }}>
    <label>Prezzo manuale (€):</label>
 <Input
   type="text"
   value={manualSalePrice ? manualSalePrice.toString().replace('.', ',') : ""}
   onChange={e => {
     let value = e.target.value.replace(/[^\d.,]/g, ''); // solo numeri, virgola o punto
     value = value.replace(',', '.'); // uniforma a punto per parseFloat

     // Consenti input parziali tipo "12." o "12.5" anche se parseFloat dà NaN temporaneo
     if (/^\d*\.?\d*$/.test(value)) {
      setManualSalePrice(value);
     }
   }}
   onBlur={() => {
      // Al momento del blur formatta a 2 decimali
      if (manualSalePrice) {
         const floatVal = parseFloat(manualSalePrice);
         if (!isNaN(floatVal)) {
         setManualSalePrice(floatVal.toFixed(2));
         }
       }
      }}
      placeholder="Es: 12,50 €"
    />
   </div>
   )}
   <label>Totale parziale (€):</label>
   <Input value={`${partialPrice} €`} readOnly />
   </div>
   <Button onClick={handleAddProduct}>Aggiungi prodotto</Button>
   <Button
    onClick={async () => {
     await handleAddProduct();
     handleFinish();
    }}
    >
    Aggiungi e termina
   </Button>
 </FormContainer>
</>
);
};

export default AddProduct;
